/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'results-charts': {
    width: 26,
    height: 32,
    viewBox: '0 0 26 32',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M10 0a3 3 0 00-3 3v.333H4.429C2.009 3.333 0 5.247 0 7.667v20C0 30.087 2.01 32 4.429 32H21.57C23.991 32 26 30.086 26 27.667v-20c0-2.42-2.01-4.334-4.429-4.334H19V3a3 3 0 00-3-3h-6zm9 5.333v.334a3 3 0 01-3 3h-6a3 3 0 01-3-3v-.334H4.429C3.06 5.333 2 6.404 2 7.667v20C2 28.929 3.06 30 4.429 30H21.57C22.94 30 24 28.929 24 27.667v-20c0-1.263-1.06-2.334-2.429-2.334H19zM9 3a1 1 0 011-1h6a1 1 0 011 1v2.667a1 1 0 01-1 1h-6a1 1 0 01-1-1V3zm6.955 10.001a1 1 0 01.752.292l3 3a1 1 0 01-1.414 1.414l-2.226-2.226-3.049 3.66a1 1 0 01-1.215.253l-2.254-1.126L7.8 20.6a1 1 0 11-1.6-1.2l2.25-3a1 1 0 011.247-.294l2.292 1.145 3.243-3.891a1 1 0 01.723-.359zM7 24a1 1 0 100 2h12a1 1 0 100-2H7z" _fill="#1F222C"/>'
  }
})
